// extracted by mini-css-extract-plugin
export var addressFields = "_m5-0";
export var animationContainer = "_m5-1";
export var footer = "_m5-2";
export var lineItems = "_m5-3";
export var modalContent = "_m5-4";
export var orderName = "_m5-5";
export var strong = "_m5-6";
export var warning = "_m5-7";